<template>  
<div> <!-- root element start -->


	<div v-if="loading == '0'" class="row">
		<div class="col-12">
      <div class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
    </div>
  </div>

  <div v-if="loading == '1'" class="row">

    <div class="col-12">
      <div class="card border-0 mb-0 pb-0">
        <div class="card-header bg-transparent border-bottom d-flex justify-content-between align-items-center">
          <span class="h5">View Quote #{{ quoteData.id }}</span><button class="btn btn-ouline-secondary" @click="cancelView"><i class="fa fa-times" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6">

      <div class="card border-0">
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Options</span></div>
            <div class="col-12"><a :href="detailUrl + quoteData.id" target="_Blank" class="" >View Quote Form</a></div>
            <div class="col-12"><a href="#" @click="emailQuote"><span class="">Email Quote</span></a></div>
            <!-- <div class="col-12"><span class="">Recreate Quote</span></div> -->
          </div>

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Quote</span></div>
            <div class="col-12"><span class="">Reference #: {{quoteData.id}}</span></div>
            <div class="col-12"><span class="">Created: {{quoteData.created_at | moment("dddd, MMMM Do YYYY") }}</span></div>
            <div class="col-12"><span class="">Type: {{quoteData.typeName}}</span></div>
            <div class="col-12"><span class="">Creator: {{quoteData.creatorName}}</span></div>
          </div>

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Organization</span></div>
            <div class="col-12"><span class="">{{quoteData.org.org_title}}</span></div>
            <div class="col-12"><span class="">{{quoteData.org.org_addr_name}}</span></div>
            <div class="col-12"><span class="">{{quoteData.org.org_addr_addr1}}</span></div>
            <div v-if="quoteData.org.org_addr_addr2 != null" class="col-12"><span class="">{{quoteData.org.org_addr_addr2}}</span></div>
            <div class="col-12"><span class="">{{quoteData.org.org_addr_city}}, {{quoteData.org.org_addr_state}} {{quoteData.org.org_addr_zip}}</span></div>
          </div>

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Contact</span></div>
            <div class="col-12"><span class="">{{quoteData.contact.contact_f_name}} {{quoteData.contact.contact_l_name}}</span></div>
            <div class="col-12"><span class="">{{quoteData.contact.contact_p_email}}</span></div>
            <div v-if="quoteData.contact.contact_p_phone != null" class="col-12"><span class="">{{quoteData.contact.contact_p_phone}}</span></div>
          </div>

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">User</span></div>
            <div class="col-12"><span class="">{{quoteData.user.user_f_name}} {{quoteData.user.user_l_name}}</span></div>
            <div class="col-12"><span class="">{{quoteData.user.user_c_email}}</span></div>
            <div class="col-12"><span class="">{{quoteData.user.user_c_phone}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div class="card border-0">
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Product</span></div>
            <div class="col-12"><span class="">{{quoteData.build.product_name}}</span></div>
          </div>


          <div class="row mb-3">
            <div class="col-12"><span class="font-weight-bold">Build</span></div>   
            <div class="col-12"><span class="">{{quoteData.build.build_name}}</span></div>
            <div class="col-12"><span class="">{{quoteData.build.build_price | currency }}</span></div>
            <div class="col-12 font-weight-bold">Options</div>
            <div v-if="quoteData.build.build_options == null" class="col-12">No Options</div>
            <div v-if="quoteData.build.build_options != null" v-for="option in quoteData.build.build_options" class="col-12">{{option.name}}</div>
          </div>

        </div>
      </div>
    </div>
	</div>


</div> <!-- root element end -->
</template>

<style>
.vuetable :focus { outline:none; }
</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'





export default {
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      detailUrl: '/utility/user/quote/viewquoteform/',
      loading: '0',
      quoteData: [],

    }
  },
  computed: {
    
  },
  watch: {
    prop3() { this.onOpen() },
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      var _this = this;
      _this.loading = '0';
      var x = _this.prop3[0];
      axios.get('/utility/user/quote/getspecificquotedetails/' + x)
        .then(function (response) {
        var a = response.data.data;
        _this.quoteData = a;
        _this.loading = '1';
        });
    },
    
    cancelView() {
      var _this = this;
      _this.$emit('onUComplete', ['quote-view'])
    },
    emailQuote() {
      var _this = this;
      _this.$emit('onSecComplete', ['quote-email', _this.prop3[0]])
    },
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

